export default "__VITE_ASSET__Ca$$3$fP__"